import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { Button, message, Popconfirm, Radio, Space, Table } from "antd";
import CompanyToken from "./company-token";

const CompanyTokens = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTokenId, setSelectedTokenId] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingToken, setEditingToken] = useState(null);

  const getData = () => {
    setLoading(true);
    serverFetch("token?internalOnly=true")
      .then(data => { setLoading(false); setItems(data); })
      .catch(e => { setLoading(false); message.error(e.userMessage || "Ошибка загрузки"); });
  };

  useEffect(getData, []);

  const handleAdd = () => {
    setEditingToken(null);
    setEditModalVisible(true);
  };

  const handleEdit = () => {
    if (!selectedTokenId) return message.warning("Выберите токен для редактирования");
    const token = items.find(item => item.id === selectedTokenId);
    if (token) { setEditingToken(token); setEditModalVisible(true); }
  };

  const handleDelete = () => {
    setLoading(true);
    serverFetch(`token/${selectedTokenId}`, { method: "DELETE" })
      .then(() => { message.success("Токен удален"); setSelectedTokenId(null); getData(); })
      .catch(e => { setLoading(false); message.error(e.userMessage || "Ошибка при удалении"); });
  };

  const handleCloseModal = (refresh) => {
    setEditModalVisible(false);
    setEditingToken(null);
    if (refresh) getData();
  };

  const columns = [
    { title: "", width: 50, render: (_, record) => <Radio checked={selectedTokenId === record.id} onChange={() => setSelectedTokenId(record.id)} /> },
    { dataIndex: "id", title: "#", width: 80 },
    { dataIndex: "code", title: "Код", width: 300 },
    { dataIndex: "active", title: "Активен", width: 100, render: (value) => value ? "Да" : "Нет" },
  ];

  return <>
    <Space style={{ marginBottom: 16 }}>
      <Button type="primary" onClick={handleAdd} disabled={loading}>Добавить</Button>
      <Button onClick={handleEdit} disabled={!selectedTokenId || loading}>Редактировать</Button>
      <Popconfirm title="Подтверждение удаления" description="Вы уверены, что хотите удалить этот токен?"
        onConfirm={handleDelete} okText="Удалить" cancelText="Отмена" disabled={!selectedTokenId}>
        <Button danger disabled={!selectedTokenId || loading}>Удалить</Button>
      </Popconfirm>
      <Button onClick={getData} disabled={loading}>Обновить</Button>
    </Space>
    
    <Table columns={columns} dataSource={items} loading={loading} rowKey="id" size="small" scroll={{ x: 'max-content' }} pagination={false} />
    {editModalVisible && <CompanyToken token={editingToken} visible={editModalVisible} onClose={handleCloseModal} />}
  </>;
}

export default CompanyTokens;